import { gql } from 'apollo-angular';

export const ReorderFunnelTacticDocument = gql/* GraphQL*/ `
  mutation reorderFunnelTactic($input: ReorderTacticInputGraphql!) {
    reorderFunnelTactic(input: $input) {
      id
    }
  }
`;
